import { OrderListDesignTokens } from '@primeuix/themes/aura/orderlist';

export const orderListTokens: OrderListDesignTokens = {
  root: {
    gap: '1.125rem',
  },
  controls: {
    gap: '0.5rem',
  },
};
